module.exports = __webpack_public_path__ + "static/markus-spiske-unsplash-b2ceedb531f53dee3a841d0feb8572f6.jpg";